// Tipos e textos das notificações do suporte, fora do arquivo do provider pra
// o Fast Refresh do Vite não reclamar de export misturado com componente.

export type NotificationKind = 'new' | 'ready' | 'transfer' | 'message';

export interface PanelNotification {
  id: number;
  source: 'support';
  kind: NotificationKind;
  title: string; // nome do cliente
  convId: number;
  read: boolean;
  at: number;
}

// Texto curto (sino, lista) e longo (banner) de cada tipo.
export const NOTIFICATION_TEXT: Record<NotificationKind, { curto: string; longo: string }> = {
  new: { curto: 'Nova conversa iniciada', longo: 'Nova conversa de suporte iniciada' },
  ready: {
    curto: 'Pronto para atendimento',
    longo: 'Cliente pronto para atendimento (triagem concluída)',
  },
  transfer: { curto: 'Transferida para você', longo: 'Este atendimento foi transferido para você' },
  message: { curto: 'Nova mensagem', longo: 'Mandou uma mensagem num atendimento seu' },
};

// Tipos que tocam o alerta insistente até alguém reagir.
export const ALERTA_INSISTENTE: ReadonlySet<NotificationKind> = new Set(['ready', 'transfer']);
